import { Button } from '@mm/components';
import classnames from 'classnames';
import { isNumber } from 'lodash';
import React from 'react';
import { PrimaryToolTip } from '../../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import './SeatsArea.pcss';

type Props = {
  userSeats?: number | null;
  userSeatsUsed?: number;
  extraUserSeats?: number;
  userSeatsDowngrade?: number;
  disabled: boolean;
  userSeatsInPlan?: number;
  changeSeats: () => void;
};

export const SeatsArea = ({
  changeSeats,
  userSeats: userSeatsProp = 0,
  userSeatsUsed: userSeatsUsedProp = 0,
  userSeatsDowngrade,
  disabled = false,
  userSeatsInPlan = 0,
}: Props) => {
  const userSeats = userSeatsProp || 0;
  const userSeatsUsed = userSeatsUsedProp || 0;

  const showDowngrade = userSeats - userSeatsUsed <= 0;
  const showPopup = isNumber(userSeatsDowngrade);

  return (
    <div className="seats-area_container">
      {disabled && (
        <PrimaryToolTip
          useHover={true}
          anchorElement={<i className="far fa-question-circle" />}
        >
          Canceled plans can&lsquo;t change seats number
        </PrimaryToolTip>
      )}

      {showPopup && !disabled && (
        <PrimaryToolTip
          useHover={true}
          anchorElement={<i className="far fa-question-circle" />}
        >
          Lowered since next billing cycle to{' '}
          {(userSeatsDowngrade || 0) + userSeatsInPlan}{' '}
          {userSeatsDowngrade === 1 ? 'seat' : 'seats'}
        </PrimaryToolTip>
      )}
      <span className="seats-area__title"> User Seats used</span>
      <div
        className={classnames('seats-area__count-area', {
          'seats-area__count-area-red': showDowngrade,
        })}
      >
        {userSeatsUsed} of {userSeats || 0}
      </div>

      <Button
        css={{ container: 'seats-area__button' }}
        color="transparent"
        onClick={changeSeats}
        disabled={disabled || showPopup}
      >
        Add/Remove seats
      </Button>
    </div>
  );
};
